// extracted by mini-css-extract-plugin
module.exports = {"root":"TotalCount_root__1A124"};